import {
    PACKAGES_DELETE_PACKAGE_OPEN_MODAL,
    PACKAGES_DELETE_PACKAGE_REQUEST,
    PACKAGES_DELETE_PACKAGE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    roleId: null,
    result: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case PACKAGES_DELETE_PACKAGE_OPEN_MODAL:
            return { ...state, openModal: true, roleId: action.payload }

        case PACKAGES_DELETE_PACKAGE_REQUEST:
            return { ...state, loading: true }

        case PACKAGES_DELETE_PACKAGE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "DELETE_PACKAGE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};